import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API, BUSINESS } from "../config";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`${API}/gallery`)
      .then((r) => r.json())
      .then((d) => setItems(d.items || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <main className="shell inner">
      <p className="eyebrow">OUR WORK</p>
      <h1 className="page-title">The Gallery</h1>
      <p className="lead darklead">A selection of alterations and tailoring from over the years — and more every week on Instagram.</p>
      {loaded && items.length === 0 ? (
        <div className="disclosure" data-testid="gallery-empty">
          <strong>Gallery coming soon</strong>
          <p>We're photographing recent work now. In the meantime, see our latest projects on Instagram <a href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer">{BUSINESS.instagramHandle}</a> — or book a fitting and experience the work firsthand.</p>
          <div className="actions">
            <Link className="button dark" to="/booking" data-testid="gallery-book-btn">Book a Private Fitting</Link>
            <a className="button subtle" href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer" data-testid="gallery-instagram-btn">Follow {BUSINESS.instagramHandle}</a>
          </div>
        </div>
      ) : (
        <div className="gallery-grid" data-testid="gallery-grid">
          {items.map((g) => (
            <figure key={g.id} className="gallery-item" data-testid={`gallery-item-${g.id}`}>
              <img src={`${process.env.REACT_APP_BACKEND_URL}${g.url}`} alt={g.caption || "Tailor Inc. work"} loading="lazy" />
              {g.caption && <figcaption>{g.caption}</figcaption>}
            </figure>
          ))}
        </div>
      )}
      <div className="section center">
        <p className="eyebrow">FOLLOW THE CRAFT</p>
        <h2>See the latest on Instagram.</h2>
        <p>New projects, before-and-afters and behind the scenes at <a href={BUSINESS.instagram} target="_blank" rel="noopener noreferrer"><strong>{BUSINESS.instagramHandle}</strong></a></p>
      </div>
    </main>
  );
}
